import { connect } from 'react-redux';

import { getUserContext } from 'selectors/user';

import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import type { RootState } from '../../reducers';

import MobileNavV2 from './MobileNavV2';

export type MobileNavV2MapStateProps = {
  userContext?: UserContext;
  activeUniversalTab: string;
};

const mapStateToProps = (state: RootState): MobileNavV2MapStateProps => ({
  userContext: getUserContext(state),
  activeUniversalTab: state.nav.activeUniversalTab,
});

export default connect(mapStateToProps)(MobileNavV2);
